export default __webpack_public_path__ + "static/media/P00124182_WF_BRAND_1HFY24ISF_Art11_1164x584.7165d72d.jpg";